import React, { useState } from 'react';
import './Layout.css';

const Layout = ({ 
  children, 
  walletData, 
  onWalletConnect, 
  onWalletDisconnect, 
  onNavigate, 
  currentView 
}) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  // Epic Battle Navigation Data
  const battleArenas = [
    {
      id: 'home',
      name: '🏰 Command HQ',
      shortName: 'HQ',
      icon: '🏰',
      description: 'Battle Command Center'
    },
    {
      id: 'solo',
      name: '⚔️ Solo Arena',
      shortName: 'Solo',
      icon: '⚔️',
      description: 'Warrior vs Arena Combat'
    },
    {
      id: 'multiplayer',
      name: '🛡️ Battle Arena',
      shortName: 'PvP',
      icon: '🛡️',
      description: 'Warrior vs Warrior Combat'
    },
    {
      id: 'arcade',
      name: '🎯 Training Grounds',
      shortName: 'Train',
      icon: '🎯',
      description: 'Skill Development Arena'
    }
  ];

  return (
    <div className="epic-battle-layout">
      {/* 🏰 EPIC BATTLE HEADER 🏰 */}
      <header className="battle-header">
        <div className="header-battle-content">
          {/* ⚡ LEGENDARY LOGO SECTION ⚡ */}
          <div className="legendary-logo-section">
            <div className="logo-container">
              <img src="./logo.png" alt="BLB" className="blb-logo" />
              <h1 className="battle-logo" onClick={() => onNavigate('home')}>
                BLB GAMING ARENA
              </h1>
            </div>
          </div>
          
          {/* 🖥️ DESKTOP BATTLE NAVIGATION 🖥️ */}
          <nav className="desktop-battle-nav">
            {battleArenas.map((arena) => (
              <button 
                key={arena.id}
                className={`battle-nav-btn ${currentView === arena.id ? 'active-arena' : ''}`}
                onClick={() => onNavigate(arena.id)}
                title={arena.description}
              >
                <span className="arena-icon">{arena.icon}</span>
                <span className="arena-name">{arena.name}</span>
              </button>
            ))}
          </nav>

          
        </div>
      </header>

      {/* 🎮 MAIN BATTLE CONTENT 🎮 */}
      <main className="main-battle-content">
        {children}
      </main>

      {/* 📱 EPIC MOBILE BOTTOM BATTLE MENU 📱 */}
      <div className="mobile-bottom-battle-menu">
        <div className="battle-menu-container">
          {battleArenas.map((arena) => (
            <button
              key={arena.id}
              className={`mobile-battle-btn ${currentView === arena.id ? 'active-mobile-arena' : ''}`}
              onClick={() => onNavigate(arena.id)}
            >
              <div className="mobile-arena-icon">{arena.icon}</div>
              <span className="mobile-arena-name">{arena.shortName}</span>
              {currentView === arena.id && (
                <div className="active-battle-indicator">⚡</div>
              )}
            </button>
          ))}
        </div>
      </div>

      {/* 🏆 EPIC BATTLE FOOTER 🏆 */}
      <footer className="battle-footer">
        <div className="footer-battle-content">
          <div className="footer-battle-left">
            <p>⚔️ BLB BATTLE ARENA PLATFORM ⚔️</p>
            <span className="footer-battle-subtitle">🔥 Powered by Blockchain Warriors & Epic Smart Contracts 🔥</span>
          </div>
          <div className="footer-battle-right">
            <span className="footer-battle-motto">🏆 BATTLE • CONQUER • EARN LEGENDARY REWARDS 🏆</span>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Layout;